import React from "react";
import { Box, CircularProgress, Fade, Typography } from "@mui/material";

export default function AdminLoadingOverlay({ open }) {
    return (
        <Fade in={open} timeout={200}>
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 12000,
                    background: "rgba(248,250,252,0.85)",
                    backdropFilter: "blur(6px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    pointerEvents: open ? "all" : "none",
                }}
            >
                <Box sx={{ textAlign: "center" }}>
                    <CircularProgress
                        size={40}
                        thickness={4}
                        sx={{ color: "var(--cise-blue)" }}
                    />
                    <Typography
                        sx={{
                            mt: 1.5,
                            fontSize: 13,
                            fontWeight: 700,
                            color: "var(--cise-text-muted)",
                        }}
                    >
                        Carregando painel…
                    </Typography>
                </Box>
            </Box>
        </Fade>
    );
}